export var defaultIsSelected = function (_a) {
    var rowIndex = _a.rowIndex, columnIndex = _a.columnIndex, data = _a.data, rowKey = _a.rowKey, columnKey = _a.columnKey;
    if (Array.isArray(data)) {
        var row = data[rowIndex];
        if (Array.isArray(row)) {
            return !!row[columnIndex];
        }
    }
    if (rowKey && typeof data === 'object' && data[rowKey]) {
        var row = data[rowKey || ''];
        if (Array.isArray(row)) {
            return !!row[columnIndex];
        }
        if (columnKey && typeof row === 'object' && row[columnKey]) {
            return !!row[columnKey];
        }
    }
    return false;
};
//# sourceMappingURL=defaultIsSelected.js.map